// Same department-name check as LeadCategoryBackfillPanel.jsx's isTechTeam() / src/routing/route/
// myworkspace/FinanceRoute.jsx - "no other person cant go to threshold view". Hiding the "Configure
// Threshold" buttons for everyone else is a UX convenience; the actual boundary is FinanceRoute.jsx
// (blocks the page itself) plus requireFinance.middleware.js (blocks the API server-side).
export const isFinance = () => {
  try {
    return JSON.parse(localStorage.getItem('cred'))?.profile?.departmentName === 'Finance';
  } catch {
    return false;
  }
};
